import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, withPrefix } from 'gatsby';
import SharedHeader from '@ecri/react-components/Header';
import { WindowLocation } from '@reach/router';
import { AppState } from '../../store';
import { determineMemberSiteUrl } from '../../util/config';
import { getAutoCompleteSuggestions } from '../../api';
import { CoreLinkMap, LinkResolver } from '@ecri/react-components/Header/types';

const replaceSlash = /\//gi;

const Header: React.FC<{ location: WindowLocation }> = ({ location }) => {
  const user = useSelector((state: AppState) => state.auth.user);
  const { allComponentTypes, allComponents, allMemberships } = useSelector(
    (state: AppState) => state.subscriptions
  );
  const [loggedIn, setLoggedIn] = useState(!(user?.expired ?? true));
  const [contactLink, setContactLink] = useState('');
  const [linkMap, setLinkMap] = useState<CoreLinkMap>({
    topics: {
      isVirtual: false,
      href: '/topics/',
    },
    myecri: {
      isVirtual: true,
      href: '/',
    },
    mycontent: {
      isVirtual: true,
      href: '/#tabs-1',
    },
    saveditems: {
      isVirtual: true,
      href: '/#tabs-2',
    },
    myaccount: {
      isVirtual: true,
      href: '/#tabs-3',
    },
    allmemberships: {
      isVirtual: true,
      href: '/',
    },
    yourmembership: {
      isVirtual: true,
      href: '/your-membership',
    },
  });

  useEffect(() => {
    setLoggedIn(!(user?.expired ?? true));
  }, [user]);

  useEffect(() => {
    setContactLink(loggedIn ? "https://home.ecri.org/clientcontactus" : "https://home.ecri.org/pages/ecri-contact-us-form");
  }, [loggedIn]);

  useEffect(() => {
    const updatedMap = Object.assign(
      {},
      ...Object.keys(linkMap).map((k) => {
        const map = (linkMap as any)[k] as LinkResolver;
        const modified = {
          ...map,
          isActive:
            withPrefix(map.href).replace(replaceSlash, '') ===
            location.pathname.replace(replaceSlash, ''),
        };

        return {
          [k]: modified,
        };
      })
    );
    setLinkMap(updatedMap);
  }, [location.pathname]);
  const handleSearchRequest = (phrase: string) => {
    const searchUrl = `SearchResults.aspx?k=${encodeURIComponent(
      phrase
    )}&Page=1&PageSize=20&Sort=relevance&mo=true`;

    //if the user is loggedIn, ensure they log into (SSO) the legacy member site before going to results
    const fullUrl = `${determineMemberSiteUrl()}${
      loggedIn ? 'pages/login.aspx?target=' : ''
    }${loggedIn ? encodeURIComponent(searchUrl) : '/Pages/' + searchUrl}`;

    window.location.replace(fullUrl);
  };

  return (
    <SharedHeader
      linkMaps={linkMap}
      membersUrl={determineMemberSiteUrl()}
      memberships={allMemberships}
      components={allComponents}
      componentTypes={allComponentTypes}
      useRelativeMemberLinks
      userName={loggedIn ? user?.profile?.given_name : ''}
      loggedIn={loggedIn}
      logOutUrl={withPrefix('/log-out')}
      linkComponent={Link}
      showBrowsingHistory
      showSearch
      showMembershipServices
      onAutoCompleteRequested={getAutoCompleteSuggestions}
      onSearchRequested={handleSearchRequest}
      contactUsLink={contactLink}
    />
  );
};

export default Header;
